import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import { InsuranceForm } from './InsuranceForm';

export const InsuranceCreate = () => (
  <Create>
    <SimpleForm defaultValues={{ active: true }}>
      <InsuranceForm />
    </SimpleForm>
  </Create>
);
